import React from 'react';
import './SustainabilityRedirect.css';
import Button from '../Button/Button';

// Truncate text function
const truncateText = (text, maxLines) => {
  // Sanitize input text
  text = text.trim().replace(/^\.+/, '').replace(/\s+/g, ' ');

  const lines = text.split('. ').reduce((acc, sentence) => {
    const currentLine = acc[acc.length - 1] || '';
    const newLine = currentLine.length > 0 ? `${currentLine}. ${sentence}` : sentence;

    if (newLine.length <= maxLines * 30) { // Adjust length for your line width
      acc[acc.length - 1] = newLine;
    } else {
      acc.push(sentence);
    }
    return acc;
  }, ['']);

  return lines.map((line, index) => (
    <span key={index}>
      {line}
      {index < lines.length - 1 && '.'}
      <br />
    </span>
  ));
};

const SustainabilityRedirect = ({ link, title, image, details, ButtonText }) => {
  return (
    <div className="SustainabilityRedirect-container">
      <div className="SustainabilityRedirect-left">
        <h2 className="SustainabilityRedirect-title">{title}</h2>
        <p className="SustainabilityRedirect-details">
          {truncateText(details, 3)}
        </p>
        <Button to={link}>{ButtonText}</Button>
      </div>
      <div className="SustainabilityRedirect-right">
        <img src={image} alt={title} className="SustainabilityRedirect-image" />
      </div>
    </div>
  );
};

export default SustainabilityRedirect;
